import React, { useState, useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import GameCardAnimationModal from './GameCardAnimationModal';
import './GameCardAnimationButton.css';

/**
 * GameCardAnimationButton displays a button that opens the GameCardAnimationModal.
 * 
 * @param {Object} props - Component props
 * @param {string} props.username - Username of the player
 * @param {string} props.overallRank - Player's overall rank in the tournament
 */
function GameCardAnimationButton({ username, overallRank }) {
  const { theme } = useContext(ThemeContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  if (!username) return null;
  
  return (
    <>
      <div className={`animation-button-container ${theme}`}>
        <button 
          className="generate-animation-button"
          onClick={() => setIsModalOpen(true)}
          aria-label="Animation"
        >
          <i className="fa-solid fa-clapperboard button-icon"></i> Animation
        </button>
      </div>
      
      {isModalOpen && (
        <GameCardAnimationModal 
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          username={username}
          overallRank={overallRank}
        />
      )}
    </>
  );
}

export default GameCardAnimationButton;
